import { observable } from 'mobx';
import { UiResponse } from '../CommonInterfaces';
import { API } from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';
import BaseLoginStore from './BaseLoginStore';
import RootStore from './RootStore';
import { ACCOUNT, View } from '../Routes';

interface PasswordResetParams {
  authId?: string;
  redirectUrl?: string;
  goto?: string;
}

export interface PasswordResetInitResponse extends UiResponse {
  params?: PasswordResetParams;
}

export interface EmailLoginPasswords {
  password: string;
  confirmPassword: string;
}

export default class ResetPasswordStore extends BaseLoginStore {
  @observable accessor emailLoginPasswords: EmailLoginPasswords = { password: '', confirmPassword: '' };
  @observable accessor passwordResetInitResponse: PasswordResetInitResponse | undefined;

  constructor(rootStore: RootStore) {
    super(rootStore);
  }

  public async init() {
    const { token: tokenParam1, IDToken1: tokenParam2 } = this.routeStore.decodedParams;
    const token = tokenParam1 || tokenParam2;
    try {
      const response = await API.get(`/email/reset-password${this.routeStore.formForwardParams}`, { params: { token } });
      this.passwordResetInitResponse = response.data;
      if (this.passwordResetInitResponse?.redirectUrl) {
        this.routeStore.route(this.passwordResetInitResponse.redirectUrl);
      }
      if (this.passwordResetInitResponse?.component === View.ACCOUNT) {
        this.routeStore.route(ACCOUNT);
      }
      this.uiStore.handleNotice(response);
    } catch (e: Error | string | any) {
      this.uiStore.handleNotice(e.response);
      this.handleError(e);
    }
  }

  public async handleLogin() {
    if (!this.passwordResetInitResponse?.params?.authId) {
      ErrorUtil.pushErrorToTeliaRumAndLogWithLocation('this.passwordResetInitResponse?.params?.authId does not have a value');
    }
    const authId = this.passwordResetInitResponse?.params?.authId;
    await this.handleLoginTemplate('/email/reset-password', this.emailLoginPasswords, { headers: authId ? { authId } : {} });
  }
}
